import { EFirebaseCustomEventName, sendEvent } from "@/firebaseinit";
import { ILogin } from "@/interfaces";
import PsiMappers from "@/mappers/PsiMappers";
import { useMainStore } from "@/store";
import { phoneCodes } from "@/utils/phoneCodes";
import { userAvatars } from "@/utils/userAvatars";
import AppointmentService from "./AppointmentService";
import { Endpoint } from "./NetworkService";
import NetworkService2 from "./NetworkService2";
export const avatars = userAvatars;
export default class UserService extends NetworkService2 {
  appointmentService;
  constructor() {
    super();
    this.appointmentService = new AppointmentService();
  }
  async login(params: ILogin) {
    var login = await this.post({ endpoint: Endpoint.login, params });
    if (login.data.type != "user") {
      throw { message: "Este email de acesso não pertence a um paciente" };
    } else {
      const store = useMainStore();
      store.saveAuthToken(login.access_token || "");
      let userData = await this.prepareUserData(login.data.id);
      return userData;
    }
  }

  async prepareUserData(userId: any) {
    let data = null;
    try {
      const user = await this.getUser(userId);
      if (user.status) {
        data = this.getFormattedUser(user.data);
      }
      if (data.partnership) {
        data.partnership.info.code = data.partnership?.partnership_code?.code;
      }
    } catch (e) {
      console.error("prepareUserData", e);
    }
    return data;
  }
  async register() {
    const store = useMainStore();
    let params = { ...store.register_info, type: "user" };
    if (params.redirectTo) {
      delete params.redirectTo;
    }
    const res: any = await this.post({ endpoint: Endpoint.users, params });
    sendEvent({
      name: EFirebaseCustomEventName.new_registration,
      data: { user_id: res.data.id },
    });
    store.saveAuthToken(res.access_token);
    let userData = await this.prepareUserData(res.data.id);
    store.updateState({ register_info: null });
    return userData;
  }
  update(id: string | number, params: any) {
    return this.put({ endpoint: `${Endpoint.users}/${id}`, params });
  }
  listNotifications(params: any) {
    return this.get({ endpoint: Endpoint.notifications, params });
  }
  sendRecoveryPasswordEmail(email: string) {
    return this.post({
      endpoint: Endpoint.recoveryPassword,
      params: { email },
    });
  }
  async syncSession() {
    const store = useMainStore();
    const data = await this.prepareUserData(store.session?.id);
    if (data) {
      store.updateSession({
        ...store.session,
        ...data,
      });
    }
  }
  deleteAccount() {
    const store = useMainStore();
    const id = store.session?.id;
    return this.delete({ endpoint: `${Endpoint.users}/${id}` });
  }
  getAvatar(userAvatar: any) {
    return avatars[userAvatar] || require("../assets/img/avatars/1.png");
  }
  async getUser(id: string) {
    return isNaN(Number(id))
      ? this.getUserBySlug(id)
      : this.get({ endpoint: `${Endpoint.users}/${id}` });
  }
  getUserBySlug(slug: string) {
    return this.get({ endpoint: `${Endpoint.usersSlug}/${slug}` });
  }
  getSettings(key: string) {
    return this.get({ endpoint: `api/${key}` });
  }

  listHomeInfo = async () => {
    let response: any = {};
    const res: any = await this.get({ endpoint: Endpoint.homeInfo });
    if (res.status) {
      response.ongoing = res.in_progress || null;
      response.scheduled_appointments =
        res.agendado.map((elem: any) =>
          this.appointmentService.prepareAppointment(elem)
        ) || [];
      response.my_psis =
        res.recent_psy
          ?.map((r: any) => this.getFormattedPsi(r.psychologist))
          .filter((p: any) => !p.deleted_at) || [];
    }
    return response;
  };
  listPsiRatings(params: any) {
    return this.get({ endpoint: Endpoint.callRating, params });
  }
  listHomeVideos = () => {
    return this.get({ endpoint: Endpoint.homeVideos });
  };

  getFormattedUser(item: any) {
    try {
      item.country_code = item.country_code || "+55";
      item.formatted_image = this.getAvatar(item.profile_image);
      item.formatted_phone = `${
        phoneCodes.find((r) => r.dial_code == item.country_code)?.flag
      }${item.country_code} ${this.getMaskedPhone(
        item.phone,
        item.country_code
      )}`;
      if (item.document_number === null) {
        item.document_number = "";
      }
      item.foreigner = item.foreigner || item.country_code !== "+55";
    } catch (e) {
      throw e;
    } finally {
      return item;
    }
  }

  getFormattedPsi = PsiMappers.mapFromApiResponse;

  getMaskedPhone(phone: string, countryCode: string) {
    try {
      let p: any = phone;
      if (p && countryCode) {
        let countryMask: any = phoneCodes.find(
          (elem) => elem.dial_code == countryCode
        );
        if (countryMask?.mask) {
          countryMask = countryMask.mask.replaceAll("9", "#");
          p = p.clear().conformToPattern(countryMask);
        }
      }
      return p;
    } catch (e) {
      console.error(e);
      return phone;
    }
  }
  resetPassword(params: any) {
    return this.post({ endpoint: Endpoint.passwordReset, params });
  }
}
